module.exports = __webpack_public_path__ + "static/media/HomeOutcomeSchoolCosReadiness.9c45a92f.jpg";